<template>
   <div class="studyclub_list">
    <el-input class="search-el" size="mini" v-model="query.title" clearable placeholder="请输入活动名称"></el-input>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
                <el-table-column label="ID" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div>{{ row.id }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="活动名称" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div style=" color: #409eff;cursor: pointer;" @click="gocompile(row.id)">{{ row.title }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="提交人数" align="center" min-width="10%">
                    <template slot-scope="{ row }">
                        <div style=" color: #409eff;cursor: pointer;" @click="gopeoplenum(row.id)">{{ row.consumer_num }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" @click="gocompile(row.id)">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" @click="gopeoplenum(row.id)">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="copy(row.share_url)">
                            复制链接
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
                    layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
   </div>
</template>

<script>
import {getstudylist} from "@/api/yxs";
import Clipboard from 'clipboard';
import {copyData } from "@/api/common";
export default {
   name: '',
   data() {
       return {
        query:{
          title:'',
          page: 1,
          limit: 20,
        },
        total:0,
        list: [
          {
            id:1,
            title:'活动名称',
            consumer_num:0,
          }
        ],
        loading:false,
       }
   },
   components: {
       
   },
   computed: {
       
   },
   mounted() {
       this.getList()
   },
   methods: {
    copy(url) {
      copyData(url)
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    getList() {
            this.loading = true;
            getstudylist(this.query).then((response) => {
                this.list = response.data.list;
                this.total = response.data.total;
                this.loading = false;
                if (this.query.page > Math.ceil(this.total / this.query.limit)) {
                    this.query.page = 1;
                    this.fetchData();
                  }
            });
        },
        fetchData(){
          this.getList()
        },
        gocompile(id){
          this.$router.push(`/studyclub/info?id=${id}`)
        },
        gopeoplenum(id){
          this.$router.push(`/studyclub/peoplelist?id=${id}`)
        },
   },
}
</script>

<style >

</style>
